import React, { useEffect, useState, useCallback } from 'react';
import { host_url } from '../App';
import KernteamLayout from '../KernteamLayout';
import BackArrow from '../BackArrow';

function AusschussVerwaltung() {
  const [ausschuesse, setAusschuesse] = useState([]);
  const [neuerName, setNeuerName] = useState('');
  const [editId, setEditId] = useState(null);
  const [editName, setEditName] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  const ladeAusschuesse = useCallback(() => {
    fetch(`${host_url}/ausschuesse`)
      .then((r) => r.json())
      .then(setAusschuesse)
      .catch(() => setError('Fehler beim Laden der Ausschüsse.'));
  }, []);

  useEffect(() => {
    ladeAusschuesse();
  }, [ladeAusschuesse]);

  const hinzufuegen = (e) => {
    e.preventDefault();
    if (!neuerName.trim()) return;
    setSaving(true);
    setError('');
    fetch(`${host_url}/ausschuesse`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ Name: neuerName }),
    })
      .then((r) => r.json())
      .then(() => {
        setNeuerName('');
        setSuccessMsg('Ausschuss erfolgreich angelegt.');
        setTimeout(() => setSuccessMsg(''), 3000);
        ladeAusschuesse();
      })
      .catch(() => setError('Fehler beim Anlegen.'))
      .finally(() => setSaving(false));
  };

  const startEdit = (ausschuss) => {
    setEditId(ausschuss.AusschussID);
    setEditName(ausschuss.Name);
  };

  const saveEdit = (id) => {
    if (!editName.trim()) return;
    setSaving(true);
    fetch(`${host_url}/ausschuesse/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ Name: editName }),
    })
      .then((r) => r.json())
      .then(() => {
        setEditId(null);
        setEditName('');
        setSuccessMsg('Ausschuss umbenannt.');
        setTimeout(() => setSuccessMsg(''), 3000);
        ladeAusschuesse();
      })
      .catch(() => setError('Fehler beim Umbenennen.'))
      .finally(() => setSaving(false));
  };

  const loeschen = (id, name) => {
    if (!window.confirm(`Ausschuss „${name}" wirklich löschen? Alle Zuordnungen werden entfernt.`)) return;
    fetch(`${host_url}/ausschuesse/${id}`, { method: 'DELETE' })
      .then(() => {
        setSuccessMsg('Ausschuss gelöscht.');
        setTimeout(() => setSuccessMsg(''), 3000);
        ladeAusschuesse();
      })
      .catch(() => setError('Fehler beim Löschen.'));
  };

  return (
    <KernteamLayout>
      <div className="container">
        <BackArrow to="/kernteamportal" />
        <h1 className="section-title blue">Ausschussverwaltung</h1>

        {error && (
          <div style={{ background: '#EE5622', color: 'white', borderRadius: '10px', padding: '10px 16px', marginBottom: '12px' }}>
            {error}
          </div>
        )}
        {successMsg && (
          <div style={{ background: '#648202', color: 'white', borderRadius: '10px', padding: '10px 16px', marginBottom: '12px' }}>
            {successMsg}
          </div>
        )}

        {/* Neuen Ausschuss anlegen */}
        <form onSubmit={hinzufuegen} style={{ marginBottom: '24px' }}>
          <label style={{ display: 'flex', flexDirection: 'column', gap: '6px', textAlign: 'left', marginBottom: '8px' }}>
            Neuer Ausschuss
            <input
              type="text"
              value={neuerName}
              onChange={(e) => setNeuerName(e.target.value)}
              placeholder="Name des Ausschusses"
              required
            />
          </label>
          <button type="submit" disabled={saving || !neuerName.trim()} className="button_boring_red blue" style={{ minHeight: 'auto' }}>
            <span className="material-symbols-outlined">add</span>
            Ausschuss anlegen
          </button>
        </form>

        {/* Liste bestehender Ausschüsse */}
        <h2 style={{ textAlign: 'left', marginBottom: '12px' }}>Bestehende Ausschüsse</h2>
        {ausschuesse.length === 0 ? (
          <p style={{ color: '#9fb05f', fontFamily: 'Circular, sans-serif' }}>Noch keine Ausschüsse angelegt.</p>
        ) : (
          <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {ausschuesse.map((a) => (
              <li
                key={a.AusschussID}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  background: 'rgba(180, 200, 130, 0.3)',
                  borderRadius: '10px',
                  padding: '12px 16px',
                }}
              >
                {editId === a.AusschussID ? (
                  <>
                    <input
                      type="text"
                      value={editName}
                      onChange={(e) => setEditName(e.target.value)}
                      style={{ flex: 1, margin: 0 }}
                    />
                    <button
                      className="button_boring_red blue"
                      style={{ width: 'auto', padding: '8px 16px', marginTop: 0, minHeight: 'auto' }}
                      onClick={() => saveEdit(a.AusschussID)}
                      disabled={saving}
                    >
                      Speichern
                    </button>
                    <button
                      style={{ width: 'auto', padding: '8px 16px', marginTop: 0, minHeight: 'auto', background: 'transparent', color: '#648202', border: '2px solid #648202' }}
                      onClick={() => setEditId(null)}
                    >
                      Abbrechen
                    </button>
                  </>
                ) : (
                  <>
                    <span style={{ flex: 1, fontSize: '1.05em', textAlign: 'left' }}>{a.Name}</span>
                    <button
                      className="button_boring_red blue"
                      style={{ width: 'auto', padding: '8px 14px', marginTop: 0, minHeight: 'auto', display: 'flex', alignItems: 'center', gap: '4px' }}
                      onClick={() => startEdit(a)}
                    >
                      <span className="material-symbols-outlined" style={{ fontSize: '1em' }}>edit</span>
                    </button>
                    <button
                      style={{ width: 'auto', padding: '8px 14px', marginTop: 0, minHeight: 'auto', background: '#EE5622', display: 'flex', alignItems: 'center', gap: '4px' }}
                      onClick={() => loeschen(a.AusschussID, a.Name)}
                    >
                      <span className="material-symbols-outlined" style={{ fontSize: '1em' }}>delete</span>
                    </button>
                  </>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    </KernteamLayout>
  );
}

export default AusschussVerwaltung;
